export default function Hero() {
  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section id="home" className="relative min-h-screen flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://public.readdy.ai/ai/img_res/1646b378f8cb472770a8d7d0e2e2ce41.jpg"
          alt="Secure Network Background"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/40 to-black/50"></div>
      </div>

      <div className="relative z-10 w-full max-w-7xl mx-auto px-6 text-center">
        <div className="inline-block mb-6 px-5 py-2 bg-cyan-500/20 backdrop-blur-sm rounded-full border border-cyan-400/30">
          <span className="text-cyan-300 text-sm font-medium">Enterprise-Grade Security</span>
        </div>

        <h1 className="text-6xl md:text-7xl lg:text-8xl font-bold text-white mb-6 leading-tight">
          Your Digital Privacy
          <br />
          Protected Everywhere
        </h1>

        <p className="text-lg md:text-xl text-gray-200 mb-10 max-w-3xl mx-auto font-light">
          Military-grade encryption for your online activities. Browse securely from anywhere in the world with ZALETELJ VPN.
        </p>

        <button
          onClick={() => scrollToSection('contact')}
          className="inline-flex items-center gap-3 px-10 py-4 bg-cyan-500 text-white text-lg font-semibold rounded-full hover:bg-cyan-600 transition-all shadow-lg hover:shadow-cyan-500/50 whitespace-nowrap cursor-pointer"
        >
          Start Secure Browsing
          <i className="ri-arrow-right-line text-xl"></i>
        </button>

        <div className="mt-16 flex items-center justify-center gap-8 text-white/80 text-sm">
          <div className="flex items-center gap-2">
            <i className="ri-shield-check-line text-cyan-400 text-xl"></i>
            <span>256-bit Encryption</span>
          </div>
          <div className="flex items-center gap-2">
            <i className="ri-global-line text-cyan-400 text-xl"></i>
            <span>Global Network</span>
          </div>
          <div className="flex items-center gap-2">
            <i className="ri-eye-off-line text-cyan-400 text-xl"></i>
            <span>Zero Logs Policy</span>
          </div>
        </div>
      </div>
    </section>
  );
}
